export default "__VITE_ASSET__Cf7_WH$p__"